const testData = [
  {
    dishType: 'Izgara & Kebab',
    name: 'Adana Kebab',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/adana.webp',
    //modalImage: 'models/adana-kebab.glb',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/adana-kebab.glb',
    price: '500.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kuşbaşı Şiş',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kusbasi.webp',
    //modalImage: 'models/kusbasi-pide.glb',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/kusbasi-kebab.glb',
    price: '530.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kemiksiz Tavuk Sarma',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kemiksizSarma.webp',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/kemiksiz-sarma.glb',
    price: '500.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kemiksiz Tavuk Gogus',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kemiksizGogus.webp',
    modalImage: undefined,
    price: '500.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Tavuk Kanat',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kanat.webp',
    modalImage: undefined,
    price: '500.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kemikli Tavuk Sarma',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kemikliPilic.webp',
    modalImage: undefined,
    price: '500.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Tavuk Pirzola',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/pilicPirzola.webp',
    //modalImage: 'models/pilic-pirzola.glb',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/pilic-pirzola.glb',
    price: '500.00',
  },
  {
    dishType: 'Lahmacun',
    name: 'Adana Lahmacun',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/adanaLahmacun.webp',
    modalImage: undefined,
    price: '350.00',
  },
  {
    dishType: 'Lahmacun',
    name: 'Antep Lahmacun',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/antepLahmacunJPG.webp',
    modalImage: undefined,
    price: '390.00',
  },
  {
    dishType: 'Pide',
    name: 'Kuşbaşı Pide',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kusbasiPide.webp',
    modalImage: undefined,
    price: '500.00',
  },
  {
    dishType: 'Pide',
    name: 'Kuşbaşı Kaşarlı Pide',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kusbasiKasarPide.webp',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/kusbasi-pide.glb',
    price: '530.00',
  },
  {
    dishType: 'Pide',
    name: 'Kıymalı Pide',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kiymaliPide.webp',
    modalImage: undefined,
    price: '500.00',
  },
  {
    dishType: 'Pide',
    name: 'Kıymalı Kaşarlı Pide',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kiymaliPide.webp',
    modalImage: undefined,
    price: '530.00',
  },
  {
    dishType: 'Pide',
    name: 'Kaşarlı Pide',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kasarliPide.webp',
    modalImage: undefined,
    price: '500.00',
  },
  {
    dishType: 'Pide',
    name: 'Kaşarlı Sucuklu Pide',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kasarliPide.webp',
    modalImage: undefined,
    price: '530.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Yağlı Kara (250 gr.)',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/DSC_0337.webp',
    modalImage: undefined,
    price: '850.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kuzu Sırt (250gr)',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/DSC_0348.webp',
    modalImage: undefined,
    price: '850.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kuzu Küşleme',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/DSC_0351.webp',
    modalImage: undefined,
    price: '850.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Külbastı (1.5 Porsiyon)',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/DSC_0371.webp',
    modalImage: undefined,
    price: '850.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Ali Nazik',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/DSC_0405.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tatlı',
    name: 'Maras Dondurma',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/Dondurma.webp',
    modalImage: undefined,
    price: '80.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Sarma Beyti',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/beytiSarma.webp',
    modalImage: undefined,
    price: '800.00',
  },
  {
    dishType: 'Meze',
    name: 'Çiğ Köfte',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/cigKofte.webp',
    modalImage: undefined,
    price: '200.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kuzu Çöp Şiş',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/copsis.webp',
    modalImage: undefined,
    price: '530.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Hasim Usta Karışık Kebap',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/hasimUstaKarisikKebap.webp',
    modalImage: undefined,
    price: '1050.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Incik Tandir',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/incik.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kemikli Kaburga',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kaburga.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tatlı',
    name: 'Kadayıf',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kadayif.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Meze',
    name: 'Kaşarlı Humus',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kasarliHumus.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Meze',
    name: 'Sucuklu Kaşarlı Humus',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kasarliHumus.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tatlı',
    name: 'Fıstıklı Sarma',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/katmer.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tatlı',
    name: 'Dondurmalı Fıstıklı Sarma',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/katmer.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tatlı',
    name: 'Kaymaklı Kadayıf',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kaymakliKadayif.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tava',
    name: 'Kuşbaşı Tava',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kusbaasiTava.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Meze',
    name: 'Kaşarlı Mantar',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/mantar.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Patlican Kebap',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/patlicanKebap.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kuzu Pirzola',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/pirzola.webp',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/pirzola.glb',
    price: '800.00',
  },
  {
    dishType: 'Tava',
    name: 'Pirzola Tava',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/pirzolaTava.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tava',
    name: 'İncik Tandır',
    description: '',
    image: '',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tava',
    name: 'Tavuk Tava',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/tavukTava.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tava',
    name: 'Kaşarlı Tavuk Tava',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/tavukTavaKasarli.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tava',
    name: 'Et tava',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/etTava.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Tava',
    name: 'Kaşarlı Et Tava',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/etTavaKasarli.webp',
    modalImage: undefined,
    price: '',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kazbaşı',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kazBasi.webp',
    modalImage: undefined,
    price: '800.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Beyti Kebab',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/beytiKebab.webp',
    modalImage: undefined,
    price: '750.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Kemiksiz Kaburga',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/kemiksiKaburga.webp',
    modalImage: undefined,
    price: '530.00',
  },
  {
    dishType: 'Izgara & Kebab',
    name: 'Ciğer Şiş',
    description: '',
    image: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/optimized/ciger.webp',
    modalImage: 'https://d1u3t4a6seeox9.cloudfront.net/hasimUstaKebap/food+models/ciger.glb',
    price: '530.00',
  },
  {
    dishType: 'İçecek',
    name: 'Kola',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Fanta',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Gazoz',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Meyve Suyu',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Ice Tea',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Soda',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Meyveli Soda',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Ayran (büyük)',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Ayran (Açık)',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Şalgam',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Şalgam (Açık)',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Su (Büyük)',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
  {
    dishType: 'İçecek',
    name: 'Su (Küçük)',
    description: '',
    image: '',
    modalImage: '',
    price: '',
  },
];

export default testData;
